import { ReactNode } from 'react';

import type { DetailCardTone } from './types';

import { cn } from '@/lib/utils';

import { DetailCardIcon } from './DetailCardIcon';

type DetailCardHeaderProps = {
  title?: ReactNode;
  icon?: ReactNode;
  iconLabel?: ReactNode;
  tone?: DetailCardTone;
  action?: ReactNode;
  hasBody: boolean;
};

export const DetailCardHeader = (props: DetailCardHeaderProps) => {
  const { title, icon, iconLabel, tone, action, hasBody } = props;

  return (
    <div
      className={cn(
        'flex min-h-10 items-center gap-3 py-1.5 pr-2 pl-3',
        hasBody && 'border-b',
      )}
    >
      <h3
        className={cn(
          'text-foreground flex min-w-0 flex-1 items-center gap-1.5 text-sm font-semibold',
          !!tone && 'gap-2',
        )}
      >
        {icon && (
          <DetailCardIcon
            tone={tone}
            label={iconLabel}
          >
            {icon}
          </DetailCardIcon>
        )}
        {title}
      </h3>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
};
